import { render, staticRenderFns } from "./ProductsTags.vue?vue&type=template&id=32e04597"
import script from "./ProductsTags.vue?vue&type=script&lang=js"
export * from "./ProductsTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports